import React from 'react'; 


import "../styles/404.css"

const NotFound = () => {
    return (  
        <>
        <main className="root-page-not-found">

<div className="text404">
<span>4</span><span className='bi bi-house-door'> </span><span>4</span>
</div>
<span>
<a href="/" className="btn btn-lg btn-warning">Réessayer</a>
</span>
        </main>
        <div className="animation404">
        <i className="icon-4404-basket  bi bi-currency-dollar"></i>
        <i className="icon-4404-cloud bi bi-cloud-slash-fill"></i>
        </div>
        </>
    );
};



export default NotFound